// extracted by mini-css-extract-plugin
module.exports = {"infoBox":"InfoBox_infoBox__1JkXW","content":"InfoBox_content__1iox2","entryList":"InfoBox_entryList__1ri26","entryPair":"InfoBox_entryPair__1q-c8"};